<template>
    <div class="foodmash-card foodmash-default">
        <div class="foodmash-frame relative">
            <!--            <div v-html="advertHtml"></div>-->
            <div class="foodmash-apps-container relative">
                <a :href="iosAppLink" :title="iosAppTitle" target="_blank" rel="nofollow" class="display-block">
                    <img class="img-responsive"
                         src="/assets/img/ios-t-min.svg"
                         :alt="iosAppTitle" width="230" height="70">
                </a>
                <a :href="androidAppLink" :title="androidAppTitle" target="_blank" rel="nofollow" class="d-block">
                    <img class="img-responsive"
                         src="/assets/img/google-t-min.svg"
                         :alt="androidAppTitle" width="230" height="70">
                </a>
            </div>

            <!--            <button @click="handleClick" class="btn btn-primary mt-8">-->
            <!--                <i aria-hidden="true" class="lnr lnr-cross" style="color: white"></i> {{ messageToShow }}-->
            <!--            </button>-->
        </div>
    </div>
</template>

<script>
import cardMixin from "../cardMixin";

export default {
    name: 'FoodmashAd',
    mixins: [cardMixin],
    props: {
        // messageToShow: String
        iosAppLink: String,
        iosAppTitle: String,
        androidAppLink: String,
        androidAppTitle: String,
    },
    // data() {
    //     return {
    //         advertHtml: ''
    //     }
    // },
    // methods: {
    //     handleClick() {
    //         this.swipe('swipeleft');
    //     }
    // },
    // created() {
    //     let self = this;
    //     const baseUrl = this.getBaseUrl();
    //
    //     axios.get(`${baseUrl}/api/v1/auth/foodmash-swipe/advertisement`).then(function (response) {
    //         self.advertHtml = response.data;
    //
    //         setTimeout(function () {
    //             document.querySelector(".foodmash-frame > div").dispatchEvent(
    //                 new CustomEvent("ad-loaded", { bubbles: true })
    //             );
    //         }, 3000);
    //     }).catch(function (error) {
    //         // do nothing
    //     });
    // }
}
</script>

<style scoped>
.foodmash-frame {
    .foodmash-apps-container {
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    a {
        display: inline-block;

        &:not(:last-child) {
            margin-bottom: 10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/FoodmashAd.vue